import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { PersonalVisitFilterComponent } from './component/personal-visit-filter.component';

@NgModule({
  declarations: [
    PersonalVisitFilterComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonLayoutModule,
    CommonTranslationModule
  ],
  exports: [
    PersonalVisitFilterComponent
  ]
})
export class PersonalVisitFilterModule { }
